<div class="modal-content">
  <div class="modal-header" *ngIf="config?.title">
      {{ config.title }}
  </div>
  <div class="modal-body">
    <div *ngIf="googleMapsLoaderService.apiLoaded | async">
      <google-map [height]="'640px'" [options]="options" [width]="'100%'">
        <map-marker #marker="mapMarker"
                    [label]="config?.label"
                    [options]="markerOptions"
                    [position]="config.position"
                    [title]="config?.title">
        </map-marker>
      </google-map>
    </div>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="ok($event)">{{ config?.okText || 'OK' }}</button>
      <button type="button" class="btn btn-secondary" (click)="cancel($event)">{{ config?.cancelText || 'Cancelar' }}</button>
  </div>
</div>
